import * as yup from 'yup'

export const newFilterClientSchema = yup.object({
	name: yup.string().required('Campo obrigatório'),
})

export const filterInFolderClientSchema = yup.object({
	folderId: yup.number().required('Campo obrigatório'),
	clientFilterId: yup.number().required('Campo obrigatório'),
})
